<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Promociones
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#ef8025;") Nueva Promoción
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Promoción
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-center='' justify-center='' wrap='' fill-height='')
                        v-flex(xs12)
                          v-select(outline
                          :items="empresas"
                          v-model="form.empresa"
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          @change="resetComboboxValues"
                          label="Empresa:")

                          v-text-field(outline
                          v-if='form.empresa'
                          v-model="form.nombre"
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          label="Nombre promoción:")

                          v-combobox(outline
                          v-if='form.empresa'
                          :items="form.empresa == 'Milo' ? tiposMilo : tiposGrupo"
                          v-model="form.tipo_cli"
                          multiple
                          small-chips
                          hide-selected
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          ref='comboTipo'
                          @blur="validateComboboxValue('tipo_cli')"
                          label="Tipo cliente:")

                          v-combobox(outline
                          v-if='form.empresa'
                          :items="form.empresa == 'Milo' ? marcasMilo : marcasGrupo"
                          v-model="form.marcas"
                          persistent-hint
                          small-chips
                          multiple
                          hide-selected
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          ref="comboMarca"
                          @blur="validateComboboxValue('marcas')"
                          label="Marcas:")

                          v-combobox(outline
                          ref="comboLinea"
                          @blur="validateComboboxValue('lineas')"
                          v-if='form.empresa'
                          :items="form.empresa == 'Milo' ? lineasMilo : lineasGrupo"
                          v-model="form.lineas"
                          multiple
                          small-chips
                          hide-selected
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          label="Lineas:")

                          v-menu(ref='menu1' v-if='form.empresa' v-model='modalI' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                              template(v-slot:activator='{ on, attrs }')
                                  v-text-field(:disabled="editedIndex != -1" outline v-model='dateFormattedI' prepend-inner-icon="description" label='Fecha inicio' persistent-hint='' v-bind='attrs' @blur='form.fecha_ini = parseDate(dateFormattedI)' v-on='on')
                              v-date-picker(v-model='form.fecha_ini' :min="min" no-title='' @input='modalI = false' dark='')

                          v-menu(ref='menu2' v-if='form.empresa' v-model='modalF' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                              template(v-slot:activator='{ on, attrs }')
                                  v-text-field(:disabled="editedIndex != -1" outline v-model='dateFormattedF' prepend-inner-icon="description" label='Fecha fin' persistent-hint='' v-bind='attrs' @blur='form.fecha_fin = parseDate(dateFormattedF)' v-on='on')
                              v-date-picker(v-model='form.fecha_fin' :min="form.fecha_ini" no-title='' @input='modalF = false' dark='')

                          v-select(outline
                          v-if='form.empresa'
                          :items="['Activo', 'Inactivo']"
                          v-model="form.estatus"
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          label="Estatus:")
                          
                        v-flex(xs6 style='padding-right:10px;')
                          v-text-field(outline
                          v-if='form.empresa'
                          hide-details=''
                          v-model="cantidad"
                          :disabled="editedIndex != -1"
                          v-mask="'##########'"
                          prepend-inner-icon="description"
                          label="Cantidad:")

                        v-flex(xs6 style='padding-left:10px;')
                          v-text-field(outline
                          v-if='form.empresa'
                          hide-details=''
                          v-model="porcentaje"
                          :disabled="editedIndex != -1"
                          prepend-inner-icon="description"
                          v-mask="'###'"
                          label="Porcentaje:")

                        v-flex(xs12 v-if='form.empresa' style="justify-content: center;display: flex;")
                          v-btn(:disabled="editedIndex != -1" style="background:#ef8025;border-radius:10px;", @click.native='addList') Agregar

                        v-flex(xs12 v-if='form.empresa' style="justify-content: center;display: flex;")
                          v-data-table.elevation-1(:disabled="editedIndex != -1" :headers='headersP', :items="form.descuentos", style="margin-top: 5px;")
                            template(slot='items', slot-scope='props')
                              td(style="padding: 0px 8px;" v-if='props.item.cantidad') {{ props.item.cantidad}}
                              td(style="padding: 0px 8px;" v-else) N/A
                              td(style="padding: 0px 8px;" v-if='props.item.porcentaje') {{ props.item.porcentaje}}
                              td(style="padding: 0px 8px;" v-else) N/A
                              td(style="padding: 0px 8px;")
                                v-btn.mx-0(:disabled="editedIndex != -1" v-if='elm' icon, @click='deleteItemPorcen(props)')
                                  v-icon(color='pink') delete

                        v-flex(xs12)
                          div
                            v-flex(v-if="loading === true", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                v-progress-circular(indeterminate='', color='primary')
                            v-flex(v-if="loading === false", xs12 sm12 md12)
                              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-btn(v-if="editedIndex == -1" style="background:#ef8025;border-radius:10px;", @click.native='save') Guardar
                                  v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de promociones
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(v-if='props.item.empresa') {{ props.item.empresa}}
            td(v-else) N/A
            td(v-if='props.item.nombre') {{ props.item.nombre}}
            td(v-else) N/A
            td(v-if='props.item.fecha_ini') {{ transformDate(props.item.fecha_ini) }}
            td(v-else) N/A
            td(v-if='props.item.fecha_fin') {{ transformDate(props.item.fecha_fin) }}
            td(v-else) N/A
            td(v-if='props.item.estatus') {{ props.item.estatus}}
            td(v-else) N/A
            td
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') visibility
                | Ver.
              v-tooltip(v-if='props.item.estatus == "Activo"' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='desactivarPromo(props.item)' v-on="on" color='red') block
                | Desactivar.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "Promociones",
  data: vm => ({
    ruta: server + ":" + port,
    loading: false,
    modalI: false,
    modalF: false,
    dialog4: false,
    form: {
      nombre: "",
      fecha_ini: new Date().toISOString().substr(0, 10),
      fecha_fin: new Date().toISOString().substr(0, 10),
      estatus: "Activo",
      empresa: "",
      tipo_cli: [],
      marcas: [],
      lineas: [],
      descuentos: []
    },
    empresas: ["Milo", "Grupo"],
    cantidad: null,
    porcentaje: null,
    dateFormattedI: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateFormattedF: vm.formatDate(new Date().toISOString().substr(0, 10)),
    min: new Date().toISOString().substr(0, 10),
    tiposMilo: [],
    tiposGrupo: [],
    marcasMilo: [],
    marcasGrupo: [],
    lineasMilores: [],
    lineasGrupores: [],
    lineasMilo: [],
    lineasGrupo: [],
    dialog: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Empresa", value: "empresa" },
      { text: "Nombre", value: "nombre" },
      { text: "Fecha Inicio", value: "fecha_ini" },
      { text: "Fecha Fin", value: "fecha_fin" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    headersP: [
      { text: "Cantidad de productos", value: "cantidad" },
      { text: "Porcentaje", value: "porcentaje" },
      { text: "Acción" }
    ],
    defaultForm: {
      nombre: "",
      fecha_ini: new Date().toISOString().substr(0, 10),
      fecha_fin: new Date().toISOString().substr(0, 10),
      estatus: "Activo",
      empresa: "",
      tipo_cli: [],
      marcas: [],
      lineas: [],
      descuentos: []
    },
    selectedMarca: null,
    cre: "",
    mod: "",
    elm: ""
  }),
  watch: {
    "form.marcas": function(val) {
      if (val && val.length > 0) {
        if (this.form.empresa == "Milo") {
          let data = this.lineasMilores.filter(el => {
            return val.some(el2 => {
              const marca = el2 && typeof el2 === "object" ? el2.value : el2;
              return (
                this.normalizeCode(el.co_lin) &&
                this.normalizeCode(el.co_lin) === this.normalizeCode(marca)
              );
            });
          });
          const fechaActual = new Date();
          data = data.filter(el => {
            const lineasExistentes = this.resultados.filter(
              resultado =>
                resultado.empresa === "Milo" &&
                resultado.lineas.some(
                  linea =>
                    this.normalizeCode(linea.value) ===
                      this.normalizeCode(el.co_subl) &&
                    this.normalizeCode(linea.linea) ===
                      this.normalizeCode(el.co_lin)
                )
            );
            if (lineasExistentes.length === 0) {
              return true;
            }
            return lineasExistentes.some(
              ({ fecha_ini, fecha_fin, estatus }) => {
                const fechaInicio = new Date(fecha_ini);
                fechaInicio.setHours(fechaInicio.getHours() + 4);
                const fechaFin = new Date(fecha_fin);
                fechaFin.setHours(fechaFin.getHours() + 4);
                const dentroDelRango =
                  fechaActual >= fechaInicio && fechaActual <= fechaFin;
                return estatus === "Inactivo" || !dentroDelRango;
              }
            );
          });
          this.lineasMilo = [];
          data.forEach(el => {
            this.lineasMilo.push({
              value: el.co_subl,
              text: el.subl_des,
              linea: el.co_lin
            });
          });
        } else {
          let data = this.lineasGrupores.filter(el => {
            return val.some(el2 => {
              const marca = el2 && typeof el2 === "object" ? el2.value : el2;
              return (
                this.normalizeCode(el.co_lin) &&
                this.normalizeCode(el.co_lin) === this.normalizeCode(marca)
              );
            });
          });
          const fechaActual = new Date();
          data = data.filter(el => {
            const lineasExistentes = this.resultados.filter(
              resultado =>
                resultado.empresa === "Grupo" &&
                resultado.lineas.some(
                  linea =>
                    this.normalizeCode(linea.value) ===
                      this.normalizeCode(el.co_subl) &&
                    this.normalizeCode(linea.linea) ===
                      this.normalizeCode(el.co_lin)
                )
            );
            if (lineasExistentes.length === 0) {
              return true;
            }
            return lineasExistentes.some(
              ({ fecha_ini, fecha_fin, estatus }) => {
                const fechaInicio = new Date(fecha_ini);
                fechaInicio.setHours(fechaInicio.getHours() + 4);
                const fechaFin = new Date(fecha_fin);
                fechaFin.setHours(fechaFin.getHours() + 4);
                const dentroDelRango =
                  fechaActual >= fechaInicio && fechaActual <= fechaFin;
                return estatus === "Inactivo" || !dentroDelRango;
              }
            );
          });
          this.lineasGrupo = [];
          data.forEach(el => {
            this.lineasGrupo.push({
              value: el.co_subl,
              text: el.subl_des,
              linea: el.co_lin
            });
          });
        }
        this.$refs.comboMarca.internalSearch = "";
      }
    },
    "form.lineas": function(val) {
      if (val && val.length > 0) this.$refs.comboLinea.internalSearch = "";
    },
    "form.tipo_cli": function(val) {
      if (val && val.length > 0) this.$refs.comboTipo.internalSearch = "";
    },
    "form.fecha_ini": function(val) {
      this.dateFormattedI = this.formatDate(val);
      this.form.fecha_fin = val;
      this.dateFormattedF = this.formatDate(val);
    },
    "form.fecha_fin": function(val) {
      this.dateFormattedF = this.formatDate(val);
    }
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    normalizeCode(value) {
      return value === null || value === undefined ? "" : String(value).trim();
    },
    hasValidComboboxValues(values, requiresLineCode = false) {
      return (
        Array.isArray(values) &&
        values.length > 0 &&
        values.every(item => {
          if (!item || typeof item !== "object") return false;
          if (!this.normalizeCode(item.value) || !this.normalizeCode(item.text)) {
            return false;
          }
          return !requiresLineCode || this.normalizeCode(item.linea) !== "";
        })
      );
    },
    getComboboxValidationMessage() {
      if (!this.hasValidComboboxValues(this.form.tipo_cli)) {
        return "Tipo cliente debe ser seleccionado y no escrito.";
      }
      if (!this.hasValidComboboxValues(this.form.marcas)) {
        return "Marcas debe ser seleccionado y no escrito.";
      }
      if (!this.hasValidComboboxValues(this.form.lineas, true)) {
        return "Lineas debe ser seleccionado y no escrito.";
      }
      return "Debe ingresar todos los campos correspondientes.";
    },
    resetComboboxValues() {
      this.form.tipo_cli = [];
      this.form.marcas = [];
      this.form.lineas = [];
    },
    validateComboboxValue(field) {
      if (!Array.isArray(this.form[field])) {
        this.form[field] = [];
        return;
      }
      this.form[field] = this.form[field].filter(
        item =>
          item && typeof item === "object" && "value" in item && "text" in item
      );
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminmilo.permisos.length; i++) {
        if (this.$store.state.adminmilo.permisos[i].ruta === "Promociones") {
          for (
            let j = 0;
            j < this.$store.state.adminmilo.permisos[i].accion.length;
            j++
          ) {
            if (this.$store.state.adminmilo.permisos[i].accion[j] === "Crear") {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    onChangeMarcas(selectedItems) {
      if (selectedItems.length > 0) {
        this.form.marcas = null;
        this.$nextTick(() => {
          console.log(selectedItems);
          this.form.marcas = selectedItems.slice();
        });
      }
    },
    transformDate(item) {
      return this.$moment(item)
        .utc()
        .format("DD/MM/YYYY");
    },
    addList() {
      this.form.descuentos.push({
        cantidad: this.cantidad,
        porcentaje: this.porcentaje
      });
      this.cantidad = null;
      this.porcentaje = null;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    initialize() {
      this.editedIndex = -1;
      Api.get("tipocliente").then(res => {
        this.tiposMilo = [];
        res.data.forEach(el => {
          this.tiposMilo.push({ value: el.tip_cli, text: el.des_tipo });
        });
      });
      Api.get2("tipocliente").then(res => {
        this.tiposGrupo = [];
        res.data.forEach(el => {
          this.tiposGrupo.push({ value: el.tip_cli, text: el.des_tipo });
        });
      });
      Api.get("marcas").then(res => {
        this.marcasMilo = [];
        res.data.forEach(el => {
          this.marcasMilo.push({ value: el.co_lin, text: el.lin_des });
        });
      });
      Api.get2("marcas").then(res => {
        this.marcasGrupo = [];
        res.data.forEach(el => {
          this.marcasGrupo.push({ value: el.co_lin, text: el.lin_des });
        });
      });
      Api.get("linea").then(res => {
        this.lineasMilores = res.data;
      });
      Api.get2("linea").then(res => {
        this.lineasGrupores = res.data;
      });
      Api.get("promociones").then(res => {
        this.resultados = res.data;
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    },
    deleteItemPorcen(item) {
      this.form.descuentos.splice(item.index, 1);
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form.fecha_ini = new Date(this.form.fecha_ini)
        .toISOString()
        .substr(0, 10);
      this.form.fecha_fin = new Date(this.form.fecha_fin)
        .toISOString()
        .substr(0, 10);
      this.form._id = item._id;
      this.dialog = true;
    },
    validacion() {
      if (
        this.form.empresa &&
        this.form.nombre &&
        this.form.fecha_ini &&
        this.form.fecha_fin &&
        this.form.estatus &&
        this.hasValidComboboxValues(this.form.tipo_cli) &&
        this.hasValidComboboxValues(this.form.marcas) &&
        this.hasValidComboboxValues(this.form.lineas, true) &&
        this.form.descuentos.length > 0
      ) {
        return true;
      } else return false;
    },
    desactivarPromo(item) {
      this.dialog4 = true;
      let info = {
        _id: item._id,
        estatus: "Inactivo"
      };
      Api.put("promociones", info)
        .then(res => {
          this.dialog4 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.initialize();
        })
        .catch(err => {
          console.log(err);
          this.dialog4 = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, llame al administrador.",
            "error"
          );
        });
    },
    save() {
      this.loading = true;
      if (this.validacion()) {
        this.form.fecha_fin =
          this.$moment(this.form.fecha_fin).format("YYYY-MM-DD") +
          "T23:59:59.000+00:00";
        if (this.editedIndex > -1) {
          Api.put("promociones", this.form)
            .then(res => {
              this.form = Object.assign({}, this.defaultForm);
              this.dialog = false;
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              this.loading = false;
              this.initialize();
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        } else {
          Api.post("promociones", this.form)
            .then(res => {
              this.form = Object.assign({}, this.defaultForm);
              this.dialog = false;
              this.$swal.fire(
                "Felicidades.!",
                "Registro realizado exitosamente.",
                "success"
              );
              this.loading = false;
              this.initialize();
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
            });
        }
      } else {
        this.loading = false;
        this.$swal.fire(
          "Oops...",
          `Error de datos: ${this.getComboboxValidationMessage()}`,
          "error"
        );
      }
    }
  }
};
</script>
<style lang="scss">
@media only screen and (max-width: 600px) {
  .wdd {
    width: 200px !important;
  }
}
.cll {
  .v-messages.theme--light {
    display: none !important;
  }
}
</style>
